import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import i18n from "../localization/i18n";

const defaultOptions = {
  headers: {
    "Content-Type": "application/json",
    accept: "text/html",
  },
};
export const instance = axios.create(defaultOptions);

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token") ?? "{}";
    config!.headers!.Authorization = token ? `Bearer ${token}` : "";
    config!.headers!.Lang = i18n.language ?? "gb";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

const responseBody = (response: AxiosResponse) => response.data;
export const requests = {
  get: (url: string, params?: any) =>
    instance
      .get(url, { params })
      .then(responseBody)
      .catch((e) => {
        throw e;
      }),
  post: (url: string, body: {}, customHeaders?: any) =>
    instance
      .post(url, body, customHeaders)
      .then(responseBody)
      .catch((e) => {
        throw e;
      }),
  put: (
    url: string,
    body: {},
    customHeaders?: AxiosRequestConfig<{}> | undefined,
  ) =>
    instance
      .put(url, body, customHeaders)
      .then(responseBody)
      .catch((e) => {
        throw e;
      }),
  patch: (url: string, body: {}, customHeaders?: any) =>
    instance
      .patch(url, body, customHeaders)
      .then(responseBody)
      .catch((e) => {
        throw e;
      }),
  delete: (url: string, config?: AxiosRequestConfig<{}>) =>
    instance
      .delete(url, config)
      .then(responseBody)
      .catch((e) => {
        throw e;
      }),
};
export const formDataHeaders = {
  headers: {
    "Content-Type": undefined,
  },
};
